// app/javascript/src/constants/theme.js
// colors currently used throughout the app
export const ICON_COLOR_WHITE = 'white';
export const ICON_COLOR_GRAY = 'gray';
export const SMALL_ICON_SIZE = '15';
export const MEDIUM_ICON_SIZE = '30';
